import { Advantage1 } from './advantage-1';
import { Advantage2 } from './advantage-2';
import { Advantage3 } from './advantage-3';
import { Advantage4 } from './advantage-4';

export const icons = [
	Advantage1,
	Advantage2,
	Advantage3,
	Advantage4,
];
